import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [meta, setMeta] = useState({ commodities: [], truck_types: [], packages: [], countries: [], currencies: [] });

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem(TOKEN_KEY);
      const pub = ["/", "/login", "/register", "/terms", "/forgot-password", "/reset-password"].includes(window.location.pathname);
      if (e?.response?.status === 401 && !pub) window.location.assign("/login?expired=1");
      else setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    api.get("/meta").then((r) => setMeta(r.data)).catch(() => {});
  }, [refresh]);

  const applyAuth = (data) => {
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => applyAuth((await api.post("/auth/login", { email, password })).data);
  const register = async (formData) => applyAuth((await api.post("/auth/register", formData)).data);
  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, meta, login, register, logout, refresh }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export const homeFor = (u) => (u?.role === "admin" ? "/admin" : u?.role === "shipper" ? "/my-loads" : "/marketplace");
